module.exports = __webpack_public_path__ + "img/bankcheck.9d054bfd.png";